import { HOTELS_BASE_URL } from 'config/env';

export * from './time';
export * from './auth';

// change date request stages
export const CHANGE_DATE_REQUEST_STAGES = {
  EDIT: 'edit',
  REVIEW: 'review',
  SUBMITTING: 'submitting',
  CONFIRMED: 'confirmed',
};

// phone numbers
export const CUSTOMER_SUPPORT_HOTLINE_AU = '1300 738 206';
export const CUSTOMER_SUPPORT_HOTLINE_INTL = '+61 2 8059 0182';
export const CUSTOMER_SUPPORT_CALL_DAYS = '7 days a week';
export const CUSTOMER_SUPPORT_CALL_HOURS = '08:30am - 5:30pm AEDT/AEST';
export const CUSTOMER_SUPPORT_LIVE_CHAT_DAYS = '7 days a week';
export const CUSTOMER_SUPPORT_LIVE_CHAT_HOURS = '08:30am - 5:30pm AEDT/AEST';

// OTA information
export const TRAVEL_AGENT_LICENSE_NUMBER = 'NSW:2TA000237';
export const ABN = '16 009 661 901';

// external URLs
export const HOTELS_SEARCH_URL = `${HOTELS_BASE_URL}/search`;
export const CONTACT_US_URL = `${HOTELS_BASE_URL}/contact-us`;
export const FAQ_URL = `${HOTELS_BASE_URL}/faqs`;
export const AUSTRALIAN_DESTINATIONS_URL = `${HOTELS_BASE_URL}/accommodation/australia`;

export const LUXE_URL = 'https://www.qantas.com/holidays/deals';

export const TERMS_AND_CONDITIONS_URL = 'https://www.qantas.com/au/en/book-a-trip/hotels-and-airbnb/terms-and-conditions.html';
export const PRIVACY_AND_SECURITY_URL = 'https://www.qantas.com/au/en/support/privacy-and-security.html';
export const TERMS_OF_USE_URL = 'https://www.qantas.com/au/en/support/terms-of-use.html';
export const TRAVEL_REQUIREMENTS_URL = 'https://www.qantas.com/au/en/travel-info/travel-updates.html#within-australia';

// GlobalModal messages
export const MODAL_HEADER_ON_CANCELLATION_FAILURE = 'There has been a problem cancelling your hotel booking';
export const MODAL_BODY_ON_CANCELLATION_FAILURE = `Please call us on ${CUSTOMER_SUPPORT_HOTLINE_AU} (outside Australia: ${CUSTOMER_SUPPORT_HOTLINE_INTL}) and we will help you cancel your booking. For other options visit our contact us page.`;

export const MODAL_HEADER_ON_CHANGE_DATE_REQUEST_FAILURE = 'There has been a problem requesting your date change';
export const MODAL_BODY_ON_CHANGE_DATE_REQUEST_FAILURE = `Please call us on ${CUSTOMER_SUPPORT_HOTLINE_AU} (outside Australia: ${CUSTOMER_SUPPORT_HOTLINE_INTL}) and we will help you amend your booking. For other options visit our contact us page.`;

export const ALERT_MESSAGE = {
  CHANGE_DATE_SUCCESS: 'Your new stay date has been confirmed',
  CHANGE_GUEST_SUCCESS: 'Your guest details have been saved',
};

// Currency symbols
export const CURRENCY_SYMBOLS: Record<string, string | undefined> = {
  AUD: '$',
  PTS: undefined,
};

export const CURRENCY_SUFFIX: Record<string, string | undefined> = {
  AUD: 'AUD',
  PTS: 'pts',
};

export const PROCESSING_MESSAGE = {
  CANCELLATION: {
    HEADER: 'We are cancelling your hotel booking',
    INFO_TEXT: 'The booking cancellation confirmation is next',
    INFO_TEXT_AFTER_10_SECS: 'It may take a minute to process your cancellation',
  },
  CHANGE_DATE: {
    HEADER: 'Just changing your booking dates',
    INFO_TEXT: 'The date change confirmation is next',
    INFO_TEXT_AFTER_10_SECS: 'It may take up to 3 minutes to process your date change…',
  },
};

export const BOOKING_LIST_LOAD_LIMIT = 20;

// qh_user_id cookie constants
export const QH_USER_ID_COOKIE = {
  NAME: 'qh_user_id',
  PATH: '/hotels',
  MAX_AGE: 365 * 24 * 60 * 60, // One year in seconds
  CRAWLER_USER_ID: 'web_crawler',
};
